











import {
  Component, Prop, Vue, Watch
} from 'nuxt-property-decorator'

interface IGalleryItem {
  caption: string;
  preview: string;
  src: string;
  thumb: string;
}

@Component
export default class ProductGallery extends Vue {
  @Prop({
    type: Array,
    default () {
      return []
    }
  }) private readonly items!: IGalleryItem[];

  image = ''

  get thumbs (): string[] {
    return this.items.map(({ thumb }) => thumb)
  }

  @Watch('items', { immediate: true })
  onItemsChanged () {
    this.setImage()
  }

  setImage (index = 0): void {
    if (this.items[index]) {
      this.image = this.items[index].src
    }
  }
}
